"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M19.1367 8.5c.7031-.5048 1.336-1.1106 1.8633-1.851-.7031.303-1.4062.5049-2.1094.5721.7735-.4711 1.336-1.1105 1.6172-1.9519-.7383.4039-1.5117.7068-2.3555.8414-.3515-.3366-.7734-.6058-1.2304-.8077C16.4648 5.1009 15.9727 5 15.4453 5c-.668 0-1.2656.1683-1.8281.4711-.5625.3366-1.0195.774-1.336 1.3125-.3515.5385-.4921 1.1443-.4921 1.75 0 .2693 0 .5385.0703.8078-1.5117-.0674-2.918-.4039-4.254-1.077C6.2696 7.625 5.1798 6.75 4.2657 5.6394c-.3515.5721-.5273 1.178-.5273 1.7837 0 .6058.1406 1.1779.457 1.6827.2813.5384.7031.9423 1.1953 1.2788-.5976 0-1.1601-.1683-1.6523-.4711v.0673c0 .8413.2812 1.5817.8437 2.2211.5625.6731 1.2657 1.0769 2.1094 1.2452-.3516.0673-.668.101-.9844.101-.211 0-.457 0-.668-.0337.211.7068.6329 1.2789 1.2657 1.75.6328.4712 1.336.6731 2.1797.6731-1.3711 1.0096-2.918 1.5144-4.6055 1.5144-.3516 0-.6328 0-.8789-.0336C4.6875 18.4952 6.586 19 8.6602 19c2.1445 0 4.0429-.5048 5.7304-1.5817 1.5117-.9423 2.7071-2.1875 3.5508-3.8029.8086-1.4808 1.2305-3.0625 1.2305-4.6779 0-.202-.0352-.3365-.0352-.4375z"
  })];
};

exports.default = _default;